export const filterTypes = {
  RANGE: 'range',
  MULTISELECT: 'multiselect',
  SELECT: 'select',
  BOOLEAN: 'boolean',
  MENU: 'menu',
};

export interface BaseFilterConfig {
  id: string;
  type: string;
  title: string;
}

export interface RangeFilterConfig extends BaseFilterConfig {
  step: number;
  min: number;
  max: number;
}

export interface RangeFilterValue {
  min: number;
  max: number;
}

export interface SelectFilterOption {
  id: string;
  title: string;
  count: number;
}

export interface SelectFilterConfig extends BaseFilterConfig {
  options: SelectFilterOption[];
}

export type SelectFilterValue = string[];

export type BooleanFilterConfig = BaseFilterConfig;

export type BooleanFilterValue = boolean;

export interface MenuFilterOption {
  id: string;
  title: string;
  children?: MenuFilterOption[];
}

export interface MenuFilterConfig extends BaseFilterConfig {
  options: MenuFilterOption[];
}

export interface MenuFilterValue {
  menu: string;
  subMenu: string[];
}

export interface TopMenuFilterConfig extends BaseFilterConfig {
  id: string;
  title: string;
  options: TopMenuFilterConfig[];
}

export interface FilterProps<Config, Value> {
  config: Config;
  value: Value;
}

export interface ChangeableFilterProps<Config, Value>
  extends FilterProps<Config, Value> {
  onChange: (value: Value) => {};
}

export interface LoadState {
  isLoading: boolean;
}

export type FilterConfig =
  | BooleanFilterConfig
  | SelectFilterConfig
  | RangeFilterConfig
  | MenuFilterConfig;

export type FilterValue =
  | BooleanFilterValue
  | SelectFilterValue
  | RangeFilterValue
  | MenuFilterValue;

export default filterTypes;
